import { z } from 'zod';

export const ClassificationSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, 'form.validation.classificationNameRequired'),
    level: z.number({ invalid_type_error: 'form.validation.levelRequired' }).int().min(0, 'form.validation.levelMin'),
    description: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateClassificationSchema = ClassificationSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateClassificationSchema = ClassificationSchema.partial();
